import { render } from "./app-modal-add-customer.vue?vue&type=template&id=ee72221a"
import script from "./app-modal-add-customer.vue?vue&type=script&lang=js"
export * from "./app-modal-add-customer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-add-customer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee72221a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee72221a', __exports__)) {
    console.log('reload')
    api.reload('ee72221a', __exports__)
  }
  
  module.hot.accept("./app-modal-add-customer.vue?vue&type=template&id=ee72221a", () => {
    console.log('re-render')
    api.rerender('ee72221a', render)
  })

}


export default __exports__